<div
  [class.product--selected]="enableSelectedBox && isSelectedProduct"
  [class.space-bottom]="currentProductNumber !== totalProductCount"
  class="tile tile--tilegraphic"
>
  <div class="tile__title">
    <div *ngIf="enableSelectedBox" class="compose-box">
      {{ "CARD" | translate }} {{ currentProductNumber }}/{{
        totalProductCount
      }}
      <span *ngIf="isSelectedProduct">{{
        "RECEIPT.COMPOSING" | translate
      }}</span>
    </div>
    <nes-heading tag="h2" size="base" class="headingXS">
      <strong>{{
        "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + product.identifier + ".TITLE"
          | translate
      }}</strong>
      <span class="pricedetails float-right"
        >€ {{ product.price | priceFormat }}</span
      >
    </nes-heading>

    <div
      *ngIf="product.route as route"
      [cypress]="'configured_route'"
      class="formfield__description route"
    >
      {{ route.from.naam }} - {{ route.to.naam }}
    </div>
  </div>
  <div class="tile__body">
    <div class="tile__content">
      <ul class="addons--list nes-mb-5">
        <ng-container *ngFor="let addon of product.addons">
          <li
            *ngIf="addon.selected"
            class="formfield__description addon float-left"
          >
            <div *ngIf="addon.price" class="float-right">
              € {{ addon.price | priceFormat }}
            </div>

            {{
              "RECEIPT.SUBSCRIPTION_DETAILS.ADDON." +
                addon.identifier +
                ".TITLE_RECEIPT" | translate
            }}
          </li>
        </ng-container>
      </ul>
      <div *ngIf="product.user as user">
        <span privacySensitive>
          {{ product.user | displayName | async }}
        </span>
      </div>
      <div class="nes-flex-wrap">
        @if (!disableEdit) {
          <nes-button
            class="nes-mr-5 nes-mt-5"
            variant="secondary"
            icon-leading="edit"
            compact
            (nesOnClick)="editProduct(product)"
            >{{ "RECEIPT.BUTTON.EDIT" | translate }}</nes-button
          >
        }
        <nes-button
          compact
          class="nes-mt-5"
          variant="tertiary"
          icon-leading="trash"
          icon="trash"
          (nesOnClick)="removeProduct(product)"
          >{{ "RECEIPT.BUTTON.DELETE" | translate }}</nes-button
        >
      </div>
    </div>
  </div>
</div>
